import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import * as React from 'react';
import { Link } from 'react-router-dom';
import styles from '../ConversationDetails.module.scss';
import { ConversationDetailsLayout } from '../ConversationDetailsLayout';
import { getConversationTitle } from '../helpers';
export const Title = ({ conversationUrl, metaConversation, layout, linkToConversation, }) => {
    const titleStrings = getConversationTitle(metaConversation);
    const { requester, subject } = titleStrings;
    const isSidebarLayout = layout === ConversationDetailsLayout.Sidebar ||
        layout === ConversationDetailsLayout.SidebarCollapsed;
    const title = (_jsxs(React.Fragment, { children: [requester, !isSidebarLayout && subject && (_jsx(Text.Paragraph, Object.assign({ as: "span", variant: "1", subdued: true }, { children: ` - ${subject}` })))] }));
    if (conversationUrl) {
        return linkToConversation ? (_jsx(Link, Object.assign({ to: conversationUrl, className: styles.titleLink }, { children: title }))) : (_jsx("span", { children: title }));
    }
    return title;
};
